<template>
    <div class="table">
  <div class="tr bg-w">
    <div class="th">名词</div>
    <div class="th">功能数值</div>
    <div class="th ">功能状态</div>
    <div class="th">修复数值</div>
    <div class="th ">修复能力</div>
  </div>
  <template v-for="(item, index) in tableData">
    <div class="tr bg-g" v-if="index % 2 == 0" :key="item.name">
      <div class="td">{{item.name}}</div>
      <div class="td">
         <div 
           v-if="item.functional_level" 
           :class="item.functional_level == '正常' ? 'circle' : item.functional_level == '衰退' ? 'sjx' : 'rect'
        ">
           {{item.functional_status}}
           <span></span>
         </div>
         <div v-else :class="item.status == '正常' ? 'circle' : item.status == '偏低' ? 'sjx' : 'rect'">
           {{item.functional_status}}
           <span></span>
         </div>
      </div>
      <div class="td">
        {{ item.functional_level || item.status }}
      </div>
      <div class="td">
        <div v-if="item.transition_level"  :class="item.transition_level == '正常' ? 'circle' : item.transition_level == '衰退' ? 'sjx' : 'rect'">
           {{item.transition}}
           <span></span>
        </div>
      </div>
      <div class="td">{{item.transition_level}}</div>
    </div>
    <div class="tr" v-else :key="item.name">
      <div class="td">{{item.name}}</div>
      <div class="td">
        <div v-if="item.functional_level" :class="item.functional_level == '正常' ? 'circle' : item.functional_level == '衰退' ? 'sjx' : 'rect'">
           {{item.functional_status}}
           <span></span>
         </div>
         <div v-else :class="item.status == '正常' ? 'circle' : item.status == '偏低' ? 'sjx' : 'rect'">
           {{item.functional_status}}
           <span></span>
         </div>
      </div>
      <div class="td"> {{ item.functional_level || item.status }}</div>
      <div class="td">
        <div v-if="item.transition_level" :class="item.transition_level == '正常' ? 'circle' : item.transition_level == '衰退' ? 'sjx' : 'rect'">
           {{item.transition}}
           <span></span>
        </div>
      </div>
      <div class="td">{{item.transition_level}}</div>
    </div>
  </template>
</div>
</template>
<script>
export default {
    name: 'ThyroidTable',
    props: {
        tableData: {
            type: Array,
            default() {
                return []
            },
        },
    },
}
</script>
<style lang="scss" scoped>
.table {
  border: 2px solid darkgray;
  width: 700px;
  margin: 30px auto;
  box-sizing: border-box;
 }
 .tr {
  display: flex;
  width: 100%;
  justify-content: space-between;
  height: 75px;
  align-items: center;
 }
 .tr .td:first-child{
   width: 43%;
 }
 .td {
  width: 19%;
  justify-content: center;
  text-align: center;
  font-size: 24px;
  color: #666;
  line-height: 75px;
 }
 .td>div{
  display: flex;
  align-items: center;
  justify-content: center;
 }
 .bg-w{
  background: #fff;
 }
 .bg-g{
  background: #c7e7f7;
 }
 .tr .th:first-child{
  width: 46%;
}
 .th {
  width: 18%;
  justify-content: center;
  background: #fff;
  color: #666;
  display: flex;
  height: 75px;
  align-items: center;
  font-size: 24px;
  font-weight: bold;
 }
 .rect {
  color: #FF7F00;
}
.rect span {
  display: inline-block;
  width: 0;
  height: 0;
  /* background-color: #FF7F00; */
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 12px solid #FF7F00;
  margin: 0 16px;
}
.circle {
  color: rgb(103, 194, 58);
}
.circle span {
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: rgb(103, 194, 58);
  margin: 0 16px;
}
.sjx span {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 12px solid rgb(64, 158, 255);
  margin: 0 8px;
}
.sjx {
  color: rgb(64, 158, 255);
}
</style>